import useFirebaseAuth from '@utils/useFirebaseAuth'
import useUserProfile, { type CurrentUser } from '@utils/useUserProfile'

const useCurrentUser = (): CurrentUser => {
  const auth = useFirebaseAuth()
  return useUserProfile({ auth })
}

export default useCurrentUser
